export const OPTHINES = {
  voteName: '2020project/2020economics_vote',
  themeColor: {
    activeBgColor: 'rgb(28 61 114)',
    inactiveBgColor: '#fdfdfd',
  },
  tabs: [
    {
      tabName: '首页',
      tabPath: '/20201008CQYS/give-like',
    },

    {
      tabName: '相关新闻',
      tabPath: '/20201008CQYS/news',
    },

    {
      tabName: '活动介绍',
      tabPath: '/20201008CQYS/Rules',
    },
  ],
};
